import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';
import { GlobalStyles } from '@mui/system';

const Copyright = ({ clinicData }) => {
    console.warn('footer received: ', clinicData);
    const theme = useTheme();

    const hasLogo = !!clinicData?.url;
    const hasContactInfo = !!clinicData?.emailAddress || !!clinicData?.clinicNumber;
    // Show contact message if clinic name exists AND at least one contact method exists
    const showContactBlock = !!clinicData?.clinicName && hasContactInfo;
    // Show clinic name fallback ONLY if no logo AND contact message is NOT shown
    const showClinicNameFallback = clinicData?.clinicName && !hasLogo && !showContactBlock;

    return (
        <>
            <GlobalStyles
                styles={{
                    '@page': {
                        size: 'A4 portrait',
                        margin: '0mm',
                        marginTop: '10mm',
                        marginBottom: '10mm',
                    },
                    '.printPageBreak': {
                        pageBreakAfter: 'always',
                    },
                    '@media print': {
                        '::-webkit-scrollbar': {
                            display: 'none',
                        },
                        body: {
                            paddingBottom: theme.spacing(2),
                        },
                        '#handout-content': {
                            position: 'relative',
                            zIndex: 0,
                        },
                        '.MuiBox-root': {
                            position: 'relative',
                            zIndex: 0,
                            pageBreakInside: 'auto',
                        },
                        '.MuiListItem-padding': {
                            pageBreakInside: 'avoid',
                        },
                        'section.title': {
                            marginBottom: '0px!important',
                            marginTop: '0px!important',
                        },
                        '.callout': {
                            marginBottom: '16px!important',
                            pageBreakInside: 'avoid',
                        },
                    },
                }}
            />

            {/* Contact block - shown for both Partner and Platform when clinic name and contact info exist */}
            {showContactBlock && (
                <Box
                    component="footer-top"
                    sx={{
                        mb: 0,
                        mt: 0,
                        '@media print': { display: 'none' },
                    }}
                >
                    <Typography variant="caption" sx={{ fontStyle: 'italic', color: '#666666', fontSize: 16 }}>
                        For any queries, please contact via{' '}
                        {clinicData?.emailAddress && (
                            <>
                                <Link href={`mailto:${clinicData.emailAddress}`} underline="always">
                                    {clinicData.emailAddress}
                                </Link>
                                {clinicData?.clinicNumber && ' or '}
                            </>
                        )}
                        {clinicData?.clinicNumber && <>{clinicData.clinicNumber}</>}.
                    </Typography>
                </Box>
            )}

            {/* Always show footer */}
            <Box
                component="footer"
                sx={{
                    pt: 1,
                    textAlign: 'left',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    '@media print': {
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        bgcolor: 'background.paper',
                        zIndex: 0,
                        overflow: 'visible',
                        py: 0,
                        display: 'none',
                    },
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        lineHeight: '1.5',
                        fontSize: 12,
                        '@media print': { fontSize: '6pt', marginBottom: '-9px' },
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 0.5,
                        alignItems: 'center',
                        flex: 1,
                    }}
                >
                    © Copyright Cetra Health. All rights reserved.
                </Typography>

                {/* Logo or Name — flex-positioned so they never overlap copyright */}
                {/* TODO removed showLogo?  */}
                {clinicData && (
                    <>
                        {hasLogo && (
                            <img
                                src={clinicData.url}
                                style={{
                                    maxHeight: 75,
                                    maxWidth: 280,
                                    objectFit: 'contain',
                                    flexShrink: 0,
                                    marginLeft: 8,
                                }}
                                alt="Clinic Logo"
                            />
                        )}
                        {showClinicNameFallback && (
                            <Box sx={{ fontSize: 16, flexShrink: 0, ml: 1 }}>
                                {clinicData.clinicName}
                            </Box>
                        )}
                    </>
                )}
            </Box>
        </>
    );
};

export default Copyright;
